export const SESSIONS_PER_PAGE = 20;
export const SUPERVISEES_PER_PAGE = 10;
export const SUPERVISORS_PER_PAGE = 10;
